import { Progress } from 'antd';
import * as S from './Description.styles';
import CountdownTimer from '../../component/CountdownTimer';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const Description: React.FC<{ setIsCountdownFinished: (finished: boolean) => void }> = ({
  setIsCountdownFinished,
}) => {
  const { t } = useTranslation();
  const [timeLeft, setTimeLeft] = useState<number>(55);
  const [seconds, setSeconds] = useState(25);
  const [progress, setProgress] = useState(0);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const audioChunks = useRef<Blob[]>([]);
  const streamRef = useRef<MediaStream | null>(null);

  useEffect(() => {
    if (seconds <= 0) return;

    const timer = setInterval(() => {
      setSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          startRecording();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [seconds]);

  const startRecording = async () => {
    setProgress(0);
    const duration = 30;
    let elapsedTime = 0;

    // start beep sound
    const beep = new Audio('/audio/beep.mp3');
    beep.play().catch((err) => console.error('Lỗi phát âm thanh:', err));

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      streamRef.current = stream;
      const mediaRecorder = new MediaRecorder(stream);
      audioChunks.current = [];

      mediaRecorder.ondataavailable = (event) => {
        audioChunks.current.push(event.data);
      };

      mediaRecorder.onstop = () => {
        setProgress(100);

        // Giải phóng tài nguyên sau khi dừng ghi âm
        streamRef.current?.getTracks().forEach((track) => track.stop());
        streamRef.current = null;
      };

      mediaRecorder.start();
      mediaRecorderRef.current = mediaRecorder;

      const progressInterval = setInterval(() => {
        elapsedTime += 0.2;
        setProgress((elapsedTime / duration) * 100);

        if (elapsedTime >= duration) {
          clearInterval(progressInterval);
          mediaRecorder.stop();
        }
      }, 200);
    } catch (error) {
      console.error('Lỗi khi truy cập micro:', error);
    }
  };

  const handleTimeout = () => {
    setIsCountdownFinished(true);
  };

  return (
    <S.Wrapper>
      <S.Header>
        <CountdownTimer initialTime={timeLeft} onTimeout={handleTimeout} />
      </S.Header>

      <S.Content>{t('page.mockTest.description1.description')}</S.Content>
      <div>
        <p>{t('page.mockTest.description1.prompt')}</p>
        <p>{t('page.mockTest.description1.interests')}</p>
        <p>{t('page.mockTest.description1.futurePlans')}</p>
        <p>{t('page.mockTest.description1.studyAbroad')}</p>
        <p>{t('page.mockTest.description1.learnEnglish')}</p>
        <p>{t('page.mockTest.description1.testChoice')}</p>
      </div>

      <S.BoxRecorded>
        <S.BoxWrapper>
          <S.BoxTitle>{t('page.mockTest.recordedAnswer')}</S.BoxTitle>
          <S.BoxStatus>
            {t('page.mockTest.currentStatus')}:
            <p>
              {seconds > 0
                ? `${t('page.mockTest.recordingIn')} ${seconds} ${t('page.mockTest.second')}`
                : `${t('page.mockTest.button.recording')}`}
            </p>
          </S.BoxStatus>
          <S.ProgressBar>
            <Progress
              percent={progress}
              showInfo={false}
              strokeColor="#616161"
              trailColor="#CCCCCC"
              size="small"
              strokeLinecap="butt"
            />
          </S.ProgressBar>
        </S.BoxWrapper>
      </S.BoxRecorded>
    </S.Wrapper>
  );
};
